    /**
     * Collection of cookie helper methods.
     * 
     * <br/><br/><strong>Note:</strong> Cookies was renamed to Biscuits by AndyB on 05/10/2018, please let the internetz know
     * @module Biscuits
     */

    /**
     * Sets a cookie against the users browser
     * @param {string} name - Name of the cookie to store
     * @param {string | number} value - Value of the cookie
     * @param {number} days - Number of days the cookie should last
     * 
     * @example
     * // Saves a cookie in the users browser for 30 days
     * setCookie("Username", "Aaron", 30);
     */
    export function setCookie(name:string, value:string|number, days:number) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date["toGMTString"]();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    /**
     * Retrieves the value of a cookie
     * @param {string} name - Name of the cookie to retrieve
     * @returns {string} String value of the cookie
     * 
     * @example
     * // Gets the value of the `username` cookie
     * const Username = getCookie("username");
     */
    export function getCookie(name:string):string {
        var nameEQ = name + '=',
            ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * Deletes a given cookie from the users browser
     * @param {string} name - Name of the cookie to delete
     * 
     * @example
     * // Deletes the `username` cookie
     * deleteCookie("username")
     */
    export function deleteCookie(name:string) {
        setCookie(name, '', -1);
    }
